import { RouteInfo } from './vertical-menu.metadata';
import Constants from '@shared/constants/constants';

// Sidebar menu Routes and data
export const ROUTES: RouteInfo[] = [
  {
    path: '/dashboard',
    title: 'Dashboard',
    icon: 'ft-home',
    class: '',
    isExternalLink: false,
    submenu: [],
    permits: [Constants.Permits.MASTER, Constants.Permits.USER]
  },
  {
    path: '',
    title: 'Tasks',
    icon: 'ft-check-square',
    class: 'has-sub',
    isExternalLink: false,
    submenu: [
      {
        path: '/task/list',
        title: 'List',
        icon: 'ft-list submenu-icon',
        class: '',
        isExternalLink: false,
        submenu: [],
        permits: [Constants.Permits.MASTER, Constants.Permits.USER]
      },
      {
        path: '/task/files',
        title: 'Files',
        icon: 'ft-file-text submenu-icon',
        class: '',
        isExternalLink: false,
        submenu: [],
        permits: [Constants.Permits.MASTER, Constants.Permits.USER]
      }
    ],
    permits: [Constants.Permits.MASTER, Constants.Permits.USER]
  },
  {
    path: '/task/schedule',
    title: 'Schedules',
    icon: 'ft-calendar',
    class: '',
    isExternalLink: false,
    submenu: [],
    permits: [Constants.Permits.MASTER, Constants.Permits.USER]
  },
  {
    path: '',
    title: 'Master Data',
    icon: 'ft-settings',
    class: 'has-sub',
    isExternalLink: false,
    submenu: [
      {
        path: '/master/users',
        title: 'Users',
        icon: 'ft-users submenu-icon',
        class: '',
        isExternalLink: false,
        submenu: [],
        permits: [Constants.Permits.USER, Constants.Permits.MASTER]
      },
      {
        path: '/master/customer',
        title: 'Customers',
        icon: 'ft-briefcase submenu-icon',
        class: '',
        isExternalLink: false,
        submenu: [],
        permits: [Constants.Permits.CUSTOMER, Constants.Permits.MASTER]
      },
      {
        path: '/master/tasktype',
        title: 'Task Types',
        icon: 'ft-tag submenu-icon',
        class: '',
        isExternalLink: false,
        submenu: [],
        permits: [Constants.Permits.MASTER]
      }
    ],
    permits: [Constants.Permits.MASTER]
  },
  {
    path: '/bridge/chat',
    title: 'AI Chat',
    icon: 'ft-message-circle',
    class: '',
    badge: 'New',
    badgeClass: 'badge badge-pill badge-primary',
    isExternalLink: false,
    submenu: [],
    permits: [Constants.Permits.ADMIN]
  },
  {
    path: '',
    title: 'System',
    icon: 'ft-settings',
    class: 'has-sub',
    isExternalLink: false,
    submenu: [
      {
        path: '/master/sites',
        title: 'Sites',
        icon: 'ft-layout submenu-icon',
        class: '',
        isExternalLink: false,
        submenu: [],
        permits: [Constants.Permits.ADMIN]
      },
      {
        path: '/master/keyword',
        title: 'Keyword',
        icon: 'ft-align-left submenu-icon',
        class: '',
        isExternalLink: false,
        submenu: [],
        permits: [Constants.Permits.ADMIN]
      },
      {
        path: '/master/blog',
        title: 'Blog',
        icon: 'ft-file-text submenu-icon',
        class: '',
        isExternalLink: false,
        submenu: [],
        permits: [Constants.Permits.ADMIN]
      }
    ],
    permits: [Constants.Permits.ADMIN]
  }
];
